import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const AllCareer = async (id) => {
  try {
    return await getData(`/website/career`);
  } catch (error) {
    console.log(error);
  }
};

export const generateInqiry = async (data) => {
  try {
    return await postData(`/website/career/generate-inquiry`, data);
  } catch (error) {
    console.log(error);
  }
};
